/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Decimal } from 'decimal.js';

import {
  Money,
  MoneyAmountData,
  ZERO,
} from '@/lib/money';

export interface FulfillmentPriceData {
  // The shipping fee of the fulfillment (VAT included)
  shipping?: MoneyAmountData;

  // TODO: Tax (for shipping fee)
  // TODO: COD fee and tax
  // TODO: VAT-exclusive shipping fee (for VAT calculation)
  // TODO: Others?
}

export class FulfillmentPrice {
  public readonly shipping: Money;

  constructor(
    public readonly currency: string,
    data: FulfillmentPriceData,
  ) {
    this.shipping =  {
      amount: (data.shipping) ? new Decimal(data.shipping) : ZERO,
      currency,
    };
  }
}
